var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "#2D2727",
    fillOpacity: 0.1,
    stroke: "#F1F1F1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1387 15.8613H27.8111C27.9485 15.8604 28.083 15.9011 28.1968 15.9781C28.3107 16.055 28.3986 16.1646 28.449 16.2924L29.6559 19.3096",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3447 21.3789H24.1378",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1725 27.5852C26.3151 27.5852 27.2414 26.6589 27.2414 25.5162C27.2414 24.3736 26.3151 23.4473 25.1725 23.4473C24.0298 23.4473 23.1035 24.3736 23.1035 25.5162C23.1035 26.6589 24.0298 27.5852 25.1725 27.5852Z",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8278 27.5852C15.9704 27.5852 16.8967 26.6589 16.8967 25.5162C16.8967 24.3736 15.9704 23.4473 14.8278 23.4473C13.6851 23.4473 12.7588 24.3736 12.7588 25.5162C12.7588 26.6589 13.6851 27.5852 14.8278 27.5852Z",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1034 25.5166H16.8965",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7585 25.5169H11.0344C10.8515 25.5169 10.6761 25.4442 10.5467 25.3149C10.4174 25.1856 10.3447 25.0102 10.3447 24.8272V15.1721C10.3447 14.9892 10.4174 14.8138 10.5467 14.6844C10.6761 14.5551 10.8515 14.4824 11.0344 14.4824H24.1378V23.7238",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1387 19.3096H29.6559V24.8268C29.6559 25.0097 29.5833 25.1851 29.4539 25.3145C29.3246 25.4438 29.1492 25.5165 28.9663 25.5165H27.2421",
    stroke: "#2D2727",
    strokeWidth: 1.37931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckimage);
export default __webpack_public_path__ + "static/media/Truckimage.e66c6414283d67a149fc830484c7fb44.svg";
export { ForwardRef as ReactComponent };